// extracted by mini-css-extract-plugin
export default {"root":"BrandDropdownField_root__9EwZw"};